import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import queryString from 'querystring';
import { updateNavbarState } from '../../actions/navbar_actions';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useCurrentUser } from '../../hooks/sessionHooks';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import { Button } from 'antd';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';

const SiteSurveysWalkthroughbyTitle = ({ companyConfig, updateNavbar, childRoutes }) => {
	const location = useLocation();
	const history = useHistory();
	const { title: siteSurveyTitle, templateId: siteSurveyTemplateId } = useParams<{
		title: string;
		templateId: string;
	}>();
	const { userType } = useCurrentUser();

	useEffect(() => {
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		if (queryParams.backlinkParams) {
			updateNavbar(
				'Back To Site Surveys',
				`/${userType}/siteSurveys/overview/all?${queryParams.backlinkParams}`
			);
		}
	}, [location.search, updateNavbar, userType]);

	const handleTabChange = useCallback(
		(key) => {
			history.push(
				`/${userType}/siteSurveys/byTitle/${siteSurveyTitle}/template/${siteSurveyTemplateId}/${key}`
			);
		},
		[history, siteSurveyTemplateId, siteSurveyTitle, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{
			key: 'locations',
			name: 'Locations',
		},
	];

	const onEdit = useCallback(() => {
		history.push(
			getLinkWIthBackLinkParams(
				location,
				'Back to Site Survey',
				`/${userType}/siteSurveys/editByTitle/${siteSurveyTitle}/template/${siteSurveyTemplateId}`
			)
		);
	}, [history, location, siteSurveyTemplateId, siteSurveyTitle, userType]);

	return (
		<DetailPageHeader
			exactPath={`/${userType}/siteSurveys/byTitle/${siteSurveyTitle}/template/${siteSurveyTemplateId}`}
			redirectPath={`/${userType}/siteSurveys/byTitle/${siteSurveyTitle}/template/${siteSurveyTemplateId}/locations`}
			backLinkText={'Back to site surveys'}
			backLinkTo={`/${userType}/siteSurveys/overview/all`}
			title={decodeURIComponent(siteSurveyTitle)}
			actions={
				<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_SITE_SURVEYS}>
					<Button key={1} ghost={true} onClick={onEdit}>
						Edit
					</Button>
				</AccessPermissionChecker>
			}
			tabs={tabs}
			backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
			handleTabChange={handleTabChange}
			checkTabActive={checkTabActive}
			childRoutes={childRoutes}
		/>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
});

const mapDispatchToProps = (dispatch) => ({
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SiteSurveysWalkthroughbyTitle)
);
